import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import {
  ImageInfo,
  ItemCastCharacterRelation,
  ItemSubType,
  ItemType,
  MainItemBasic,
  MainType
} from '@irohalab/mira-sdk-angular';
import { DEFAULT_IMAGE_INFO, imageRatio } from '../utils';

interface RelatedItem {
  id: string;
  name?: string;
  nameCn?: string;
  type?: ItemType;
  subType?: ItemSubType;
  coverImage: ImageInfo;
  relationType: string | undefined;
  imageRatio: number;
  publicTime: string;
  isCollection: boolean;
}

interface ItemWithRelation {
  name?: string;
  nameCn?: string;
  itemId: string | null | undefined;
  coverImage: ImageInfo;
  imageRatio: number;
  itemList: RelatedItem[];
}

@Component({
    selector: 'app-cast-character-item-list',
    imports: [
    UIResponsiveImageWrapper
],
    templateUrl: './cast-character-item-list.component.html',
    styleUrl: './cast-character-item-list.component.less'
})
export class CastCharacterItemListComponent implements OnChanges {
  @Input()
  relationMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemCastCharacterRelation[];

  itemsWithRelation: ItemWithRelation[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    this.initializeItemsWithRelation();
  }

  private initializeItemsWithRelation(): void {
    if (this.relationMainItems?.length > 0 && this.relations?.length > 0) {
      const charaIdSet = new Set<string>();
      for (const relation of this.relations) {
        if (!relation.relatedCharacterId || charaIdSet.has(relation.relatedCharacterId)) {
          continue;
        }
        charaIdSet.add(relation.relatedCharacterId);
        const charaItem = this.relationMainItems.find(item => item.id === relation.relatedCharacterId);
        if (charaItem) {
          let charaImage = charaItem.coverImage;
          if (!charaImage) {
            charaImage = DEFAULT_IMAGE_INFO;
          }
          const itemIdList = this.relations
            .filter(rel => rel.relatedCharacterId === relation.relatedCharacterId)
            .map(rel => rel.mainItemId);
          const itemWithRelation: ItemWithRelation = {
            itemId: charaItem.id,
            name: charaItem.name,
            nameCn: charaItem.nameCn,
            coverImage: charaImage,
            imageRatio: imageRatio(charaImage),
            itemList: this.relationMainItems.filter(item => itemIdList.includes(item.id) && item.mainType === MainType.Item)
              .map(item => {
                let itemImage = item.coverImage;
                if (!itemImage) {
                  itemImage = DEFAULT_IMAGE_INFO;
                }
                return {
                  id: item.id,
                  name: item.name,
                  nameCn: item.nameCn,
                  type: item.type,
                  subType: item.subType,
                  coverImage: itemImage,
                  imageRatio: imageRatio(itemImage),
                  relationType: relation.relationType
                } as RelatedItem;
              })
          }

          this.itemsWithRelation.push(itemWithRelation);
        }
      }
    }
  }
}
